import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { M_FLOW_HEX, L_FLOW_HEX } from '../../../constants';
export const DIESEL_HYDROTREATING_R_CONFIG = {
    type: ERFElement.DieselFuelHydrotreatingRBlock,
    icon: 'DieselFuelHydrotreatingRBlock_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Сырьё',
                    position: Position.Left,
                    style: { top: 166, left: 7, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'target_material_hydrogen_flow',
                    type: 'target',
                    name: 'ВСГ',
                    position: Position.Left,
                    style: { top: 146, left: 7, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_product_flow',
                    type: 'source',
                    name: 'Продукт',
                    position: Position.Right,
                    style: { top: 148, right: 7, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 175, left: 7, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 175, right: 7, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFDieselFuelHydrotreatingRBlockNode.config.js.map